import type { CinemaAction } from "../types/entities/action"

const CYRILLIC: Record<string, string> = {
    а: "a",
    б: "b",
    в: "v",
    г: "g",
    д: "d",
    е: "e",
    ё: "e",
    ж: "zh",
    з: "z",
    и: "i",
    й: "y",
    к: "k",
    л: "l",
    м: "m",
    н: "n",
    о: "o",
    п: "p",
    р: "r",
    с: "s",
    т: "t",
    у: "u",
    ф: "f",
    х: "h",
    ц: "ts",
    ч: "ch",
    ш: "sh",
    щ: "sch",
    ъ: "",
    ы: "y",
    ь: "",
    э: "e",
    ю: "yu",
    я: "ya",
}

export function slugifyActionTitle(title: string): string {
    let out = ""
    for (const ch of title.trim().toLowerCase()) {
        if (CYRILLIC[ch] != null) out += CYRILLIC[ch]
        else if (/[a-z0-9]/.test(ch)) out += ch
        else out += "-"
    }
    return out.replace(/-+/g, "-").replace(/^-|-$/g, "").slice(0, 80)
}

export function actionSlug(
    action: Pick<CinemaAction, "id" | "title">,
    all: Array<Pick<CinemaAction, "id" | "title">> = [],
): string {
    const base = slugifyActionTitle(action.title) || "akciya"
    const clash = all.some(item => item.id !== action.id && slugifyActionTitle(item.title) === base)
    return clash ? `${base}-${action.id}` : base
}

export function actionPath(
    action: Pick<CinemaAction, "id" | "title">,
    all: Array<Pick<CinemaAction, "id" | "title">> = [],
): string {
    return `/promo/${actionSlug(action, all)}`
}

export function findActionBySlug(actions: CinemaAction[], slug: string): CinemaAction | undefined {
    if (/^\d+$/.test(slug)) return actions.find(item => String(item.id) === slug)
    return (
        actions.find(item => actionSlug(item, actions) === slug) ??
        actions.find(item => slugifyActionTitle(item.title) === slug)
    )
}

export function parseActionIdFromSlug(slug: string): number | null {
    if (/^\d+$/.test(slug)) return Number(slug)
    const tail = slug.match(/-(\d+)$/)
    return tail ? Number(tail[1]) : null
}
